import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { showAlertModal } from '../../../../actions';
import FormWrapper from '../FormWrapper';
import Dialog from '../../../common/Dialog';

class SiteForm extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      bID: '',
      name: '',
      dir: '',     // this should match the sDir field in JSCustomer - can be edited, but make sure we change the dir in the JSCustomer table also
      dataPlan: '0',
      timezone: '',
      reportErrors: false,
      customerId: 'none',
      customerName:'',
      url: '',            // this is "domain " field from JSCustomer - can be edited, but make sure we change the domain in the JSCustomer table
      siteEdit: false,
      showDeleteSitePrompt: false
    }
  }

  componentDidMount(){
    if(this.props.site){
      // we are editing a current site
      this.setState({
        bID: this.props.site.bID,
        siteEdit: true,
        name: this.props.site.sName,
        dir: this.props.site.sDir,
        dataPlan: this.props.site.bDataPlanGB,
        timezone: this.props.site.sTimezone,
        reportErrors: this.props.site.fReportErrors === 0 ? false : true,
        customerId: this.props.site.bCustomerID,
        customerName: this.props.site.sCustomerName,
        url: this.props.site.url,
        showDeleteSitePrompt: false
      })
    }
  };

  componentDidUpdate() {
    if(this.props.site && this.props.site.bID && this.props.site.bID !== this.state.bID){
      this.setState({
        bID: this.props.site.bID,
        siteEdit: true,
        name: this.props.site.sName,
        dir: this.props.site.sDir,
        dataPlan: this.props.site.bDataPlanGB,
        timezone: this.props.site.sTimezone,
        reportErrors: this.props.site.fReportErrors === 0 ? false : true,
        customerId: this.props.site.bCustomerID,
        customerName: this.props.site.sCustomerName,
        url: this.props.site.url,
        showDeleteSitePrompt: false
      })
    }
  };

  handleChange = (e, type) => {
    if(type === 'reportErrors' || type === 'public'){
      e.persist();
      this.setState({ [type]: e.target.checked });
      return
    };
    if(type === 'customerId') {
      // we need to change the dir and url to match customer selected dir and domain
      let targetCustomer = this.props.customers.find(customer => customer.bID === parseInt(e.target.value));
      if(targetCustomer){
        this.setState({ dir: targetCustomer.sDir, url: targetCustomer.sDomain, customerName: targetCustomer.sName });
      };
    };

    this.setState({ [type]: e.target.value });
  };

  onSubmit = async() => {
    if(this.state.name.length < 1 || this.state.customerId === 'none' || this.state.timezone === '') {
      this.props.showAlertModal(['WARNING', 'Name, Customer and Timezone must be provided. Please revise.'])
      return;
    };

    const reqBody = {
      "id": this.state.siteEdit ? this.props.site.bID : null,
      "name": this.state.name,
      "dir": this.state.dir,
      "customerId": parseInt(this.state.customerId),
      "dataPlan": this.state.dataPlan && this.state.dataPlan.length > 0 ? parseInt(this.state.dataPlan) : 0,
      "timezone": this.state.timezone,
      "reportErrors": this.state.reportErrors ? 1 : 0,
      "userId": this.props.userData.bID,
    };

    await axios({
      method: 'post',
      url: this.props.cloudAPI + 've/project?device=' + this.props.deviceList[0],
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + this.props.token
      },
      withCredentials: true,
      data: reqBody

    }).then(response => {
      // insert returns new id in response.data.data[0], update returns null in response.data.data[0]
      this.props.showAlertModal(['SUCCESS', 'Site details successfully saved.'])

      this.props.updateData('site', {
        bID: (this.state.siteEdit) ? this.props.site.bID : response.data.data[0],
        sName: this.state.name,
        bCustomerID: parseInt(this.state.customerId),
        sCustomerName: this.state.customerName,
        sDir: this.state.dir,
        url: this.state.url,
        bDataPlanGB: parseInt(this.state.dataPlan),
        sTimezone: this.state.timezone,
        fReportErrors: this.state.reportErrors === true ? 1 : 0,
      });

      !this.state.siteEdit && this.props.closeForm()

    }).catch(error => {
      console.log(error)
      this.props.showAlertModal(['ERROR', 'Unable to save site details.'])
    })
  };

  undoEdit = () => {
    this.setState({
        bID: this.props.site.bID,
        siteEdit: true,
        name: this.props.site.sName,
        dir: this.props.site.sDir,
        dataPlan: this.props.site.bDataPlanGB,
        timezone: this.props.site.sTimezone,
        reportErrors: this.props.site.fReportErrors === 0 ? false : true,
        customerId: this.props.site.bCustomerID,
        customerName: this.props.site.sCustomerName,
        url: this.props.site.url,
        showDeleteSitePrompt: false
    });
  };

  promptDeleteSite = () => {
    this.setState({ showDeleteSitePrompt: true });
  };

  deleteSite = async (site) => {
    const reqBody = {
      "id": this.props.site.bID,
      "del": 1,
    };
    await axios({
      method: 'post',
      url: `${this.props.cloudAPI}ve/project?device=${this.props.deviceList[0]}`,
      headers: {
        'Content-Type': 'Application/json',
        'Authorization': 'Bearer ' + this.props.token
      },
      withCredentials: true,
      data: reqBody

    }).then(response => {
      this.props.showAlertModal(['SUCCESS', 'Site successfully deleted.'])
      this.props.updateData('site', {}, true)
      this.props.closeForm();

    }).catch(error => {
      console.log(error)
      this.props.showAlertModal(['ERROR', 'Unable to delete site.'])
      this.setState({ showDeleteSitePrompt: false })
    })
  }

  onBlur = (e) => {
    // edit
    if (this.props.site) {
      const report = this.props.site.fReportErrors === 0 ? false : true

      if ((this.state.name !== this.props.site.sName)
        || (parseInt(this.state.customerId) !== parseInt(this.props.site.bCustomerID))
        || (parseInt(this.state.dataPlan) !== parseInt(this.props.site.bDataPlanGB))
        || (this.state.reportErrors !== report)
        || (this.state.timezone !== this.props.site.sTimezone)) {
          this.props.onBlur(e, this.onSubmit)
      }

    // new
    } else {
      if (this.state.name.trim() !== '' || this.state.customerId !== 'none' || parseInt(this.state.dataPlan) !== 0 || this.state.timezone !== '' || this.state.reportErrors) {
          this.props.onBlur(e, this.onSubmit)
      }
    }
  }

  render() {
    return (
      <FormWrapper heading={this.state.siteEdit ? "Edit Site" : "New Site"}
                   onBlur={this.onBlur}
                   closeForm={this.props.closeForm}
                   onSubmit={this.onSubmit}
                   onDelete={this.promptDeleteSite}
                   edit={this.state.siteEdit}
                   undoEdit={this.undoEdit} >

        <div style={{ width: '100%' }}>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: this.state.siteEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.siteEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Name:</p>
            <input
              name="name"
              type="text"
              value={this.state.name}
              style={{ fontSize: '1.6vmin', width: '50%' }}
              onChange={(e) => this.handleChange(e, 'name')} />
          </div>

          {/* if customer changes (editing current site) - need to pull in sDir and Domain from JSCustomer selected  */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: this.state.siteEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.siteEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Customer:</p>
            <select value={this.state.customerId} onChange={e => this.handleChange(e, 'customerId')} style={{ fontSize: '1.6vmin', width: '50%' }}>
              <option value={'none'}>None</option>
              {this.props.customers.map( c => (
                    <option key={c.bID} value={c.bID}>{c.sName}</option>
                ))
              }
            </select>
          </div>

          {/* this should match the sDir field in JSCustomer - can be edited, but make sure we change the dir in the JSCustomer table also */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: this.state.siteEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.siteEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: "14vmin" }}>File Directory: </p>
            <input
                name="file directory"
                type="text"
                value={this.state.dir}
                style={{ fontSize: '1.6vmin' }}
                disabled
                onChange={(e) => this.handleChange(e, 'dir')} />
          </div>

          {/* this should match the sDomain field in JSCustomer - can be edited, but make sure we change the domain in the JSCustomer table also  */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: this.state.siteEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.siteEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: "14vmin" }}>Domain: </p>
            <input
                name="domain"
                type="text"
                value={this.state.url}
                style={{ fontSize: '1.6vmin' }}
                disabled
                onChange={(e) => this.handleChange(e, 'url')} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: this.state.siteEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.siteEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Timezone:</p>
            <select name="timezone" value={this.state.timezone} onChange={(e) => this.handleChange(e, 'timezone')} style={{ fontSize: '1.6vmin', width: '50%' }}>
              <option value=''>Please select</option>
              {Intl.supportedValuesOf('timeZone').map(tz => <option key={tz} value={tz}>{tz}</option>)}
            </select>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: this.state.siteEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.siteEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: '14vmin' }}>Data Plan:</p>
            <input
              name="dataPlan"
              type="number"
              min="0"
              value={this.state.dataPlan}
              style={{ fontSize: '1.6vmin', width: '5vmin' }}
              onChange={(e) => this.handleChange(e, 'dataPlan')} />
            <p style={{ margin: 0, marginLeft: '1vmin', fontSize: '1.6vmin' }}>GB</p>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: this.state.siteEdit ? '1vmin' : '4vmin', marginBottom: '1.6vmin', marginRight: this.state.siteEdit ? '1vmin' : 0 }}>
            <p style={{ margin: 0, fontSize: '1.6vmin', width: "14vmin" }}>Report Errors: </p>
            <input
                name="reportErrors"
                type="checkbox"
                value={this.state.reportErrors}
                checked={this.state.reportErrors}
                style={{ fontSize: '1.6vmin' }}
                onChange={(e) => this.handleChange(e, 'reportErrors')} />
          </div>

        </div>

        {this.state.showDeleteSitePrompt &&
          <Dialog
            boxStyle={{width: '50vmin'}}
            title="WARNING"
            content={
              <div>
                <p>Are you sure you want to delete this site?</p>
                <p>{this.props.site.sName}</p>
                <p style={styles.dialogHighlight}>Users will no longer have access to this site once removed.</p>
                <p>This action cannot be undone.</p>
              </div>
            }
            buttons={[
              {label: 'Delete', onClick: () => this.deleteSite(this.props.site)},
              {label: 'Cancel', onClick: () => this.setState({ showDeleteSitePrompt: false })},
            ]}
          />
        }

      </FormWrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {}
}
export default connect(mapStateToProps, { showAlertModal } )(SiteForm)

const styles = {
  dialogHighlight: {
    fontWeight: 'bold',
  },
}